/*
 * Connection config
 * @BASE_DEV_URL see json-server setup in package.json
 */
// import hosts from '../assets/hosts.json';
// export const BASE_PROD_URL = 'https://open.gemexch.bet/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'https://' + window?.location?.hostname +'/api'
// export const BASE_DEV_URL = 'https://lotus365.io/api'
// export const BASE_DEV_URL = 'https://9xzfo.com/api'
// export const BASE_DEV_URL = 'https://dev.gemexch.co/api'
export const BASE_URL = window.location.hostname.includes("127.0.0.1")
  ? "https://playbrooffical.com"
  : window.location.origin;
export const BASE_DEV_URL = `${BASE_URL}/api/v1/`
// export const BASE_DEV_URL = `https://www.r247.in/api/v1/`
// export const BASE_URL = 'https://superbets.in'
// export const BASE_PROD_URL = 'https://open.gemexch.bet/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'https://' + window?.location?.hostname +'/api'
// export const BASE_DEV_URL = 'https://lotus365.io/api'
// export const BASE_DEV_URL = `${BASE_URL}/api/v1/`;
// export const BASE_DEV_URL = 'https://superbets.in/api/v1/'
// export const BASE_DEV_URL = 'https://api.diamond222.com/api/'
export const BASE_DEV_URL_NEW = `${BASE_URL}/api/v1/`;
//  export const BASE_DEV_URL = '/api'
export const BASE_DEV_URL_PUBLIC = "https://lcexch365.club/api/v1/";
// export const BASE_DEV_URL_PUBLIC = 'https://api.gemexch.co/api/public'
//  export const BASE_DEV_URL_PUBLIC = '/api/public'
// export const BASE_DEV_URL_PUBLIC = 'http://localhost:5006/api/public'
// export const BASE_DEV_URL_PUBLIC = 'https://9xzfo.com/api/public'
// const fs = require('fs');
// let rawdata = fs.readFileSync('/assets/hosts.json');
// let hosts = JSON.parse(rawdata);
// export const BASE_CONFIG_URL_PUBLIC = 'https://f1ojm.com/api/config/google-config'
// export const BASE_CONFIG_URL_PUBLIC = 'https://dev.gemexch.co/api/config/google-config'
export const BASE_CONFIG_URL_PUBLIC =
  "https://api.gemexch.co/api/config/google-config";
// export const BASE_VERIFY_OTP_URL = 'http://localhost:5006/api'
// export const BASE_VERIFY_OTP_URL = '/api'
export const BASE_VERIFY_OTP_URL = "https://dev.gemexch.co/api";
// export const BASE_CONFIG_URL_PUBLIC = 'http://localhost:5006/api/config/google-config'
export const APP_VERSION_XML = "https://f1ojm.com/assets/app-update.xml";

export const IS_B2C = true;
export const OTP_VERIFY = true;

export function getHostnameFromURL(url) {
  try {
    const parsedURL = new URL(url);
    return parsedURL.hostname;
  } catch (error) {
    console.error("Invalid URL provided:", error);
    return null;
  }
}

export const hosts = {
  localhost: {
    appName: "UNICON 365",
    version: "v1.1",
    email: "",
    mobiNumber: "+910000000000",
    telegram: "unicon365",
    instagram: "unicon.365",
    facebook: "",
    title:
      "Unicon365 - Best Online Betting Site in India | Download Sports Betting App",
    metaDescription:
      "Unicon365 - India's premier online betting site! Enjoy top-tier sports betting with our user-friendly app. Download now for the best betting experience in India.",
    betbyThemeName: "lotus-fair",
    isWhatsappOnSignUp: true,
    whatsappLink: "https://wa.me/0000000000?text=Hello%20there!",
    whatsappSupportLink: "https://wa.me/0000000000?text=Hello%20there!",
    downloadAppLink: "",
    youtube: "https://www.youtube.com/channel/UCVjpAWT_y_mlCzZ9xBjJW2g",
    appVersionLink: "",
    telegramSupportLink: "",
    showSignupOption: true,
    showSignupbyRefer: true,
    showLoginWithOtp: true,
    // variableCss: '/whitelabel/lotus365original.com/variable.css',
    themeColor: "#c10931",
    domain: "Unicon365",
    showDeposit: true,
    showWithdrawal: true,
    isContactUsVisisble: true,
    isWhatsappLinkVisible: true,
    isTelegramVisible: true,
    isInstaVisible: true,
    isEmailVisible: true,
    isFBVisible: true,
    managerID: "65be41419bc2a7610b7511b4",
    adminName: "ADMINTEST",
    transactionpassword: "806736",
    siteurl: "diamond222.com",
    // siteurl: 'betacular365.in',
  },
};

const metaDesc =
  window?.location?.hostname?.replace("app.", "").toUpperCase() +
  " - India's premier online betting site! Enjoy top-tier sports betting with our user-friendly app. Download now for the best betting experience in India.";

export const CONFIG = {
  isContactUsVisisble: true,
  isWhatsappLinkVisible: true,
  whatsappLink: "0000000000",
  whatsappSupportLink: "0000000000",
  isWhatsappOnSignUp: false,
  showSignupOption: IS_B2C,
  showSignupbyRefer: false,
  showLoginWithOtp: false,
  telegramSupportLink: "0000000000",
  appUrl: "",
  logo:
    "/assets/images/" +
    window?.location?.hostname?.replace("app.", "").replace("www.", "") +
    "/logo.png",
  appleTouchIcon:
    "/assets/images/" +
    window?.location?.hostname?.replace("app.", "").replace("www.", "") +
    "/logo180.png",
  favicon:
    "/assets/images/" +
    window?.location?.hostname?.replace("app.", "").replace("www.", "") +
    "/favicon.png",
  variableCss: false,
  // lmtTheme: '/whitelabel/' + (window?.location?.hostname?.replace('app.', '').replace('www.', '') || "localhost") + '/lmt-theme.css',
  manifestUrl:
    "/whitelabel/" +
    (window?.location?.hostname?.replace("app.", "").replace("www.", "") ||
      "localhost") +
    "/manifest.json",
  isTelegramVisible: false,
  telegram: "localhost",
  isInstaVisible: false,
  instagram: "localhost",
  appName: "localhost",
  version: "v1.0",
  isEmailVisible: false,
  email: "",
  mobiNumber: "0000000000",
  youtube: "",
  isFBVisible: false,
  facebook: "gemexch",
  themeColor: "#c10931",
  showDeposit: IS_B2C,
  showWithdrawal: IS_B2C,

  title:
    window?.location?.hostname?.replace("app.", "").toUpperCase() +
      " - Best Online Betting Site in India | Download Sports Betting App" ||
    "",
  metaDescription: metaDesc || "",
  googleAnalytics: "",
  betbyThemeName: "lotus-fair",
  oneSignalAppiD: "",
  oneSignalSafariWebID: "",
  downloadAppLink: "",
  appVersionLink: "",
  domain: window?.location?.hostname?.replace("app.", "").toUpperCase() || "",

  transactionImg: "",
  managerID: "",
  adminName: "",
  transactionpassword: "",
  siteurl: window?.location?.href || "",
};
